"use client";
import React from "react";
import dynamic from "next/dynamic";
import { ContentContainer, Layout, TP } from "../../../components/molecules";

// Dynamically import the OurPeopleCarousel component
const OurPeopleCarousel = dynamic(() => import("./OurPeopleCarousel"));

const CurveShapeMobile = () => {
  return (
    <svg
      width="92"
      height="100"
      viewBox="0 0 92 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.3611 21.8915C62.2029 19.5291 59.7986 18.5398 55.217 17.219L51.0759 16.0743L50.1341 13.5629C47.543 6.84323 41.6165 2.7938 31.9066 1.08154C23.4665 -0.375054 15.3479 0.865732 4.92811 5.04328C1.41866 6.50299 0.0392915 7.27443 0.0683571 7.90201C0.108323 8.76494 2.79481 8.20813 11.6216 5.2836C27.1078 0.163853 45.4053 4.81959 47.339 14.3212C47.5915 15.5281 47.4382 15.6138 44.0348 15.968C39.1855 16.507 36.3302 17.6613 33.5028 20.2687C31.2402 22.3389 31.0942 22.5815 31.2032 24.9349C31.346 27.1689 31.521 27.5539 33.4318 28.9198C36.0776 30.8806 40.1896 31.3977 43.6315 30.1769C45.8364 29.4066 46.6329 28.7801 48.2643 26.6605C49.3382 25.235 50.4205 23.1408 50.6761 21.8711C50.8944 20.6424 51.3926 19.5187 51.7438 19.4632C52.7902 19.1395 56.8637 20.5232 61.6048 22.7408C65.7448 24.711 66.842 25.4856 72.3825 30.5356C77.8445 35.5893 78.7583 36.6476 81.1849 40.6626C82.6347 43.1112 84.5942 47.2264 85.5807 49.8537C88.7743 58.5501 88.3986 71.6572 84.666 81.0282C83.9614 82.7904 81.2852 86.9631 78.0707 91.3965C75.1554 95.5017 72.7265 99.0733 72.7374 99.3087C72.7956 100.564 74.3474 99.2734 78.9413 94.0685C82.6784 89.886 84.527 87.3632 86.0472 84.5413C91.8965 73.3427 92.6245 59.3545 88.023 47.4214C86.7311 44.14 84.8574 40.178 83.8397 38.5742C81.3794 34.6787 70.1945 24.0332 66.3611 21.8915ZM47.572 21.897C46.5743 24.9699 45.2313 26.5258 42.6861 27.5871C39.1356 29.0094 33.9119 27.4038 33.792 24.815C33.7266 23.403 36.0978 21.1312 38.7178 19.9878C41.1845 18.9302 47.091 18.3029 47.8708 19.0136C48.1581 19.2755 48.0219 20.5789 47.572 21.897Z"
        fill="#ABE69E"
      />
    </svg>
  );
};

const OurPeople = ({ data }) => {
  const CurveShape = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="205"
        height="223"
        viewBox="0 0 205 223"
        fill="none"
      >
        <path
          d="M55.899 48.4376C65.2217 43.1409 70.6122 40.923 80.8843 37.9616L90.1686 35.3952L92.2801 29.7646C98.0894 14.6991 111.377 5.62017 133.146 1.78126C152.069 -1.48445 170.271 1.29742 193.633 10.6636C201.501 13.9362 204.593 15.6658 204.528 17.0729C204.439 19.0076 198.416 17.7592 178.626 11.2023C143.905 -0.276213 102.882 10.162 98.5467 31.4649C97.9808 34.1707 98.3244 34.3629 105.955 35.1569C116.827 36.3655 123.229 38.9533 129.568 44.7991C134.641 49.4405 134.968 49.9845 134.724 55.2609C134.403 60.2695 134.011 61.1326 129.727 64.195C123.795 68.5912 114.576 69.7505 106.859 67.0136C101.916 65.2865 100.13 63.8818 96.4723 59.1297C94.0646 55.9336 91.6381 51.2385 91.0649 48.3918C90.5756 45.6371 89.4585 43.1177 88.6711 42.9931C86.3252 42.2676 77.1922 45.3698 66.5627 50.3415C57.2807 54.7588 54.8208 56.4956 42.3989 67.8178C30.1529 79.1482 28.1042 81.5209 22.6639 90.5226C19.4132 96.0123 15.0201 105.239 12.8084 111.129C5.64818 130.627 6.49045 160.013 14.8592 181.023C16.4388 184.974 22.439 194.329 29.6459 204.269C36.1819 213.473 41.6276 221.48 41.6032 222.008C41.4728 224.822 37.9935 221.929 27.694 210.259C19.3153 200.882 15.1708 195.226 11.7624 188.899C-1.35186 163.792 -2.98392 132.43 7.33253 105.676C10.229 98.319 14.43 89.4362 16.7116 85.8404C22.2277 77.1067 47.3043 53.2392 55.899 48.4376ZM98.0245 48.4497C100.261 55.3393 103.272 58.8277 108.979 61.2071C116.939 64.3959 128.651 60.7962 128.919 54.9921C129.066 51.8262 123.75 46.7329 117.876 44.1695C112.345 41.7982 99.1027 40.3917 97.3545 41.9852C96.7104 42.5723 97.0157 45.4947 98.0245 48.4497Z"
          fill="#ABE69E"
        />
      </svg>
    );
  };

  return (
    <Layout className="mt-36 mb-36">
      <ContentContainer>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[36%_1fr] gap-20">
          <div>
            <div className="hidden md:block absolute -top-24 -left-24">
              <CurveShape />
            </div>
            <div className="block md:hidden absolute -top-10 left-36">
              <CurveShapeMobile />
            </div>
            <h3 className="mb-16 font-extrabold text-[32px] leading-[32px] 2xl:text-5xl">
              {data?.info?.title}
            </h3>
            <TP size="14px" lineHeight="32px">
              {data?.info?.description}
            </TP>
          </div>
          <OurPeopleCarousel data={data?.gallery} />
        </div>
      </ContentContainer>
    </Layout>
  );
};

export default OurPeople;
